/** @jsx jsx */
import { graphql } from 'gatsby';
import uniqBy from 'lodash/uniqBy';
import React from 'react';
import { jsx } from 'theme-ui';
import LandingPage from '../components/LandingPage/LandingPage';

export default function ExhibitorsTemplate({
  data: { event, featuredExhibitors, fallbackExhibitors },
  pageContext,
  location,
}) {
  const { minFeaturedExhibitors, limit } = pageContext;
  const exhibitors = React.useMemo(() => {
    if (featuredExhibitors?.nodes?.length > minFeaturedExhibitors) {
      return featuredExhibitors.nodes.slice(0, limit);
    }
    return uniqBy(
      [
        ...(featuredExhibitors?.nodes ?? []),
        ...(fallbackExhibitors?.nodes ?? []),
      ],
      ({ brandId }) => brandId
    ).slice(0, limit);
  }, [featuredExhibitors, fallbackExhibitors, minFeaturedExhibitors, limit]);
  return (
    <LandingPage
      {...pageContext}
      event={event}
      exhibitors={exhibitors}
      producers={[]}
      location={location}
    />
  );
}

export const pageQuery = graphql`
  query LandingTemplate(
    $locale: String
    $filter: ExhibitorFilterInput
    $sort: ExhibitorSortInput
    $limit: Int = 100
  ) {
    featuredExhibitors: allExhibitor(
      filter: $filter
      sort: $sort
      limit: $limit
    ) {
      nodes {
        brandId
        ...LandingPage_FeaturedExhibitors
      }
    }
    fallbackExhibitors: allExhibitor(
      filter: {
        locale: { eq: $locale }
        mainImage: { url: { ne: null } }
        logo: { url: { ne: null } }
      }
      sort: { fields: [contentLevel], order: [DESC] }
      limit: $limit
    ) {
      nodes {
        ...LandingPage_FeaturedExhibitors
      }
    }
    event(locale: { eq: $locale }) {
      ...LandingPage
    }
  }
`;
